import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Link from "next/link";
import { memo } from "react";
import { breadcrumbsButton } from "./BreadcrumbsButton";
export const BreadcrumbsLink = /*#__PURE__*/ memo((param)=>{
    let { children, className, href, prefix, suffix, ...restOfProps } = param;
    return /*#__PURE__*/ _jsxs(Link, {
        "data-testid": "BREADCRUMBS_LINK",
        className: breadcrumbsButton({
            class: className
        }),
        href: href,
        ...restOfProps,
        children: [
            !!prefix && /*#__PURE__*/ _jsx("div", {
                className: "shrink-0",
                children: prefix
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "truncate",
                children: children
            }),
            !!suffix && /*#__PURE__*/ _jsx("div", {
                className: "shrink-0",
                children: suffix
            })
        ]
    });
});
BreadcrumbsLink.displayName = "BreadcrumbsLink";
